import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clapperboard, LogOut, LayoutDashboard, Wallet } from "lucide-react";

export const Header = ({ variant = "app" }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 w-full border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group shrink-0">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-[#00F0FF] text-black">
            <Clapperboard className="h-5 w-5" strokeWidth={2} />
          </span>
          <span className="font-display text-xl font-bold tracking-tight">
            Narrative<span className="text-[#00F0FF]">Vault</span>
          </span>
        </Link>

        <nav className="flex items-center gap-2 md:gap-4">
          {user ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="hidden sm:flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors px-3 py-2"
              >
                <LayoutDashboard className="h-4 w-4" /> Dashboard
              </Link>
              <Link
                to="/dashboard/payouts"
                data-testid="nav-payouts"
                className="hidden sm:flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors px-3 py-2"
              >
                <Wallet className="h-4 w-4" /> Payouts
              </Link>
              <div className="flex items-center gap-2 pl-2">
                {user.picture ? (
                  <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover ring-1 ring-white/20" />
                ) : (
                  <span className="grid place-items-center h-8 w-8 rounded-full bg-[#00F0FF]/20 text-[#00F0FF] text-sm font-semibold">
                    {(user.name || user.email || "?")[0].toUpperCase()}
                  </span>
                )}
                <button
                  onClick={handleLogout}
                  data-testid="logout-btn"
                  className="grid place-items-center h-9 w-9 rounded-lg hover:bg-white/10 text-white/70 hover:text-white transition-colors"
                  title="Log out"
                >
                  <LogOut className="h-4 w-4" />
                </button>
              </div>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-signin"
                className="whitespace-nowrap text-sm text-white/80 hover:text-white transition-colors px-3 sm:px-4 py-2"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                data-testid="nav-getstarted"
                className="whitespace-nowrap text-sm font-semibold bg-[#00F0FF] text-black rounded-full px-4 sm:px-5 py-2.5 hover:scale-105 transition-transform duration-300 cyan-glow"
              >
                Start Free
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
